(function () {
  // wait for body dataset.country
  function waitForCountryAttribute(cb) {
    const body = document.body;
    if (body.dataset.country) return cb(body.dataset.country);
    const mo = new MutationObserver(() => {
      if (body.dataset.country) {
        mo.disconnect();
        cb(body.dataset.country);
      }
    });
    mo.observe(body, { attributes: true });
  }

  // wait for element to appear in DOM
  function waitForSelector(selector, cb, timeout = 5000) {
    const el = document.querySelector(selector);
    if (el) return cb(el);
    const start = Date.now();
    const mo = new MutationObserver(() => {
      const found = document.querySelector(selector);
      if (found) {
        mo.disconnect();
        return cb(found);
      }
      if (Date.now() - start > timeout) mo.disconnect();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  // decode HTML entities (works for &quot;, &amp;, numeric entities, etc.)
  function decodeHtmlEntities(str) {
    if (!str) return str;
    const txt = document.createElement('textarea');
    txt.innerHTML = str;
    return txt.value;
  }

  // rounding helper
  function roundToNextFive(amount) {
    const ceilVal = Math.ceil(amount);
    const remainder = ceilVal % 5;
    return remainder === 0 ? ceilVal : ceilVal + (5 - remainder);
  }

  // make collapsible visible/hide in mobile
  function setCollapsibleVisible(collapsibleEl, visible) {
    if (!collapsibleEl) return;
    const btn = collapsibleEl.querySelector(".Collapsible__Button");
    const inner = collapsibleEl.querySelector(".Collapsible__Inner");

    // prefer using attributes the theme expects
    if (btn) btn.setAttribute("aria-expanded", visible ? "true" : "false");
    if (inner) {
      if (visible) {
        inner.style.height = inner.scrollHeight ? inner.scrollHeight + "px" : "auto";
        inner.style.overflow = "visible";
      } else {
        inner.style.height = "0";
        inner.style.overflow = "hidden";
      }
    }
    // ensure the wrapper itself is shown/hidden
    collapsibleEl.style.display = visible ? "" : "none";
  }

  // main update function: decode JSON, pick code, insert HTML
  function applyDeliveryContent(holder, country) {
    // read raw attribute (safer than dataset when HTML entities present)
    const raw = holder.getAttribute("data-delivery-json");
    if (!raw) return;

    let jsonString;
    try {
      jsonString = decodeHtmlEntities(raw); // turn &quot; etc into real quotes
    } catch (e) {
      console.error("Error decoding delivery JSON attribute:", e);
      return;
    }

    let data;
    try {
      data = JSON.parse(jsonString || "{}");
    } catch (e) {
      console.error("Invalid delivery JSON after decoding:", e, jsonString);
      return;
    }

    const code = (country || "REST").trim().toUpperCase();

    const allowedCountries = ["GB", "US", "DE", "FR", "IT", "NL", "CA"];

    const desktopWrapper = document.querySelector(".ProductTabs__DeliveryReturns");
    const mobileCollapsible = holder.closest(".Collapsible") || document.querySelector(".Product__MobileTabs .Collapsible");
    const wrapper = desktopWrapper || mobileCollapsible;
    // hide/show logic
    if (!allowedCountries.includes(code)) {
      if (desktopWrapper) desktopWrapper.style.display = "none";
      if (mobileCollapsible) setCollapsibleVisible(mobileCollapsible, false);
      holder.innerHTML = ''; // clear content
      return;
    } else {
      if (desktopWrapper) desktopWrapper.style.display = "";
      if (mobileCollapsible) mobileCollapsible.style.display = "";
    }

    const content = data[code] || data["REST"] || data["GB"] || Object.values(data)[0];
    if (!content) return;

    let deliveryText = content.delivery || "";

    // replace amount strings with rounded nearest 5
    deliveryText = deliveryText.replace(
      /(\b(?:free\s+when\s+you\s+spend|free\s+for\s+orders|when\s+you\s+spend|orders\s+over|spend\s+over|for\s+orders\s+over)\b[^0-9\S\r\n]*)([$£€¥]?)(\d+(?:\.\d+)?)/ig,
      (full, prefix, symbol, amountStr) => {
        const num = parseFloat(amountStr);
        if (isNaN(num)) return full;
        const rounded = roundToNextFive(num);
        const outSymbol = symbol || "$";
        return `${prefix}${outSymbol}${rounded}`;
      }
    );

    holder.innerHTML = `
      <p><strong>Delivery</strong></p>
      ${deliveryText}

      <p style="margin-top: 12px;"><strong>Returns &amp; Exchanges</strong></p>
      ${content.returns || ""}
    `;

    // Re-measure only if the customer has already opened the accordion.
    if (mobileCollapsible) {
      const btn = mobileCollapsible.querySelector(".Collapsible__Button");
      const inner = mobileCollapsible.querySelector(".Collapsible__Inner");
      if (btn && btn.getAttribute("aria-expanded") === "true" && inner) {
        requestAnimationFrame(() => {
          inner.style.height = inner.scrollHeight ? inner.scrollHeight + "px" : "auto";
          inner.style.overflow = "visible";
        });
      }
    }
  }

  function applyAllDeliveryContent(country) {
    const holders = document.querySelectorAll("#delivery-returns-data");
    if (!holders.length) return;
    holders.forEach((holder) => applyDeliveryContent(holder, country));
  }

  function currentCountry() {
    return (
      (document.body && document.body.dataset.country) ||
      (document.documentElement && document.documentElement.dataset.country) ||
      ""
    );
  }

  waitForCountryAttribute(applyAllDeliveryContent);

  if (typeof MutationObserver === "function") {
    const observer = new MutationObserver(() => applyAllDeliveryContent(currentCountry()));
    const observe = () => {
      if (document.body) {
        observer.observe(document.body, { attributes: true, attributeFilter: ["data-country"] });
        applyAllDeliveryContent(currentCountry());
      }
    };

    if (document.body) {
      observe();
    } else {
      document.addEventListener("DOMContentLoaded", observe, { once: true });
    }
  }

})();
